import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 40px;
    }
`;

export const BlockTitle = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};
    margin-bottom: 16px;
  
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const SwiperContainer = styled.div`
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;

    & > div:first-of-type {
        margin-left: 20px;
    }
`;

export const BlockArray = styled.div`
    display: flex;
    gap: 16px;
`;

export const StyledButton = styled(BaseButton)`
    ${FONTS.MediumXS};
    width: 240px;
    margin-top: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        margin-top: 20px;
    }
`;

export const CardRowWrapper = styled.div<{ cardGap: number }>`
    gap: ${(props) => props.cardGap}px;
`;
